import React, { useEffect, useRef } from 'react';

const GoldenCube = () => {
  const cubeRef = useRef(null);

  useEffect(() => {
    let rotation = 0;
    const animate = () => {
      rotation += 0.5;
      if (cubeRef.current) {
        cubeRef.current.style.transform = `rotateX(${rotation * 0.5}deg) rotateY(${rotation}deg)`;
      }
      requestAnimationFrame(animate);
    };
    animate();
  }, []);

  return (
    <div style={{
      width: '400px',
      height: '400px',
      perspective: '1000px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div 
        ref={cubeRef}
        style={{
          width: '300px',
          height: '300px',
          position: 'relative',
          transformStyle: 'preserve-3d',
          transition: 'transform 0.1s linear'
        }}>
        {/* Front */}
        <div style={{
          position: 'absolute',
          width: '300px',
          height: '300px',
          background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
          border: '2px solid #FFD700',
          transform: 'translateZ(150px)',
          boxShadow: '0 0 40px rgba(255, 215, 0, 0.5), inset 0 0 40px rgba(255, 215, 0, 0.3)',
          opacity: 0.9
        }} />
        {/* Back */}
        <div style={{
          position: 'absolute',
          width: '300px',
          height: '300px',
          background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
          border: '2px solid #FFD700',
          transform: 'rotateY(180deg) translateZ(150px)',
          boxShadow: '0 0 40px rgba(255, 215, 0, 0.5), inset 0 0 40px rgba(255, 215, 0, 0.3)',
          opacity: 0.9
        }} />
        {/* Right */}
        <div style={{
          position: 'absolute',
          width: '300px',
          height: '300px',
          background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
          border: '2px solid #FFD700',
          transform: 'rotateY(90deg) translateZ(150px)',
          boxShadow: '0 0 40px rgba(255, 215, 0, 0.5), inset 0 0 40px rgba(255, 215, 0, 0.3)',
          opacity: 0.9
        }} />
        {/* Left */}
        <div style={{
          position: 'absolute',
          width: '300px',
          height: '300px',
          background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
          border: '2px solid #FFD700',
          transform: 'rotateY(-90deg) translateZ(150px)',
          boxShadow: '0 0 40px rgba(255, 215, 0, 0.5), inset 0 0 40px rgba(255, 215, 0, 0.3)',
          opacity: 0.9
        }} />
        {/* Top */}
        <div style={{
          position: 'absolute',
          width: '300px',
          height: '300px',
          background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
          border: '2px solid #FFD700',
          transform: 'rotateX(90deg) translateZ(150px)',
          boxShadow: '0 0 40px rgba(255, 215, 0, 0.5), inset 0 0 40px rgba(255, 215, 0, 0.3)',
          opacity: 0.9
        }} />
        {/* Bottom */}
        <div style={{
          position: 'absolute',
          width: '300px',
          height: '300px',
          background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
          border: '2px solid #FFD700',
          transform: 'rotateX(-90deg) translateZ(150px)',
          boxShadow: '0 0 40px rgba(255, 215, 0, 0.5), inset 0 0 40px rgba(255, 215, 0, 0.3)',
          opacity: 0.9
        }} />
      </div>
    </div>
  );
};

export default GoldenCube;